import * as THREE from 'three';
import React, { useState, useMemo } from 'react'
import { const_var, params } from '../../../../../../../redux/reducers/reducer'
import { delModel, extrudeSettings, textureAnisotropy, wainscotTrimModel } from '../../../../../../../utils/Functions';
import { CSG } from '../../../../../../../assets/libs/csg-lib';
import { useDispatch } from 'react-redux';
import { setWallCloseStateWrap } from '../../../../../../../action';
import { controls } from '../../../../../../../redux/reducers/common/eventReducer';
import { MaterialTrim, MaterialWainScotTrim, MaterialWainScotTrimNew } from '../../../../../CustomMaterial';
import { useThree } from '@react-three/fiber';

const TrimModel = () => {
    const dispatch = useDispatch();
    const { gl } = useThree();

     
    
    const [wallCloseState, setWallCloseState] = useState(0);

    const mainColor = useMemo(() => (params.p_t_c.replace("0x","#")), [params.p_t_c]) 
    const wainscotColor = useMemo(() => (params.p_w_c_c.replace("0x","#")), [params.p_w_c_c]) 

    const backStorageTrimModelOne = useMemo(() => {
        const model = new THREE.Shape();

        let overHeight = 0;
        if (params.p_r_s === 1) {
            overHeight = 0;
        } else {
            overHeight = -0.1
        }

        if (params.p_u_c) {
            model.moveTo(params.p_d / 2 - parseInt(params.p_u_t) - 0.03, 0);
            model.lineTo(params.p_d / 2 - parseInt(params.p_u_t) - 0.03, (params.singleSlope && params.freeStandingSide === "right" && params.p_l_w === 'Open') ? params.p_h + ((params.p_r_p / 12) * params.p_w) + overHeight : (params.p_r_w === 'Open' && !params.p_c_p_r) ? params.p_h : wallCloseState - overHeight);
            model.lineTo(params.p_d / 2 - parseInt(params.p_u_t) + 0.2, (params.singleSlope && params.freeStandingSide === "right" && params.p_l_w === 'Open') ? params.p_h + ((params.p_r_p / 12) * params.p_w) + overHeight : (params.p_r_w === 'Open' && !params.p_c_p_r) ? params.p_h : wallCloseState - overHeight);
            model.lineTo(params.p_d / 2 - parseInt(params.p_u_t) + 0.2, 0);
            model.closePath();
        }

        return model;
    
    }, [params.p_h, params.p_w, params.p_d, params.p_r_p, params.p_r_s, params.p_u_c, params.p_u_t, params.singleSlope, wallCloseState, params.p_c_p_r])

    const backStorageTrimModelTwo = useMemo(() => {
        const model = new THREE.Shape();
        const trimOffsetHeight = (params.p_r_p / 12) * 0.18

        let overHeight = 0;
        if (params.p_r_s === 1) {
            overHeight = 0;
        } else {
            overHeight = -0.1
        }

        if (params.p_u_c) {
            model.moveTo(params.p_d / 2 - parseInt(params.p_u_t) - 0.03, 0);
            model.lineTo(params.p_d / 2 - parseInt(params.p_u_t) - 0.03, (params.singleSlope && params.freeStandingSide === "right") ? params.p_h + ((params.p_r_p / 12) * params.p_w) + overHeight : (params.p_r_w === 'Open' && !params.p_c_p_r) ? params.p_h - trimOffsetHeight : wallCloseState - overHeight);
            model.lineTo(params.p_d / 2 - parseInt(params.p_u_t) + 0.05, (params.singleSlope && params.freeStandingSide === "right") ? params.p_h + ((params.p_r_p / 12) * params.p_w) + overHeight : (params.p_r_w === 'Open' && !params.p_c_p_r) ? params.p_h - trimOffsetHeight : wallCloseState - overHeight);
            model.lineTo(params.p_d / 2 - parseInt(params.p_u_t) + 0.05, 0);
            model.closePath();
        }

        return model;
    
    }, [params.p_h, params.p_w, params.p_d, params.p_r_p, params.p_r_s, params.p_u_c, params.p_u_t, params.singleSlope, wallCloseState, params.p_c_p_r]);

    const mainTrimModel = useMemo(() => {
    
        /**********************cutting hole using CSG for Wainscot Trim************************/
    
        const storageLength = params.p_d - parseInt(params.p_u_t) + 0.18
        const meshWainscotTrimModel = new THREE.Mesh(new THREE.ExtrudeGeometry(wainscotTrimModel(0.14, 0.17), extrudeSettings(params.p_d - storageLength + 0.35)), new THREE.MeshStandardMaterial({ color: 'red' }))
        const meshWainscotDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('right', 'wall'), extrudeSettings(1)), new THREE.MeshStandardMaterial({ color: 'blue' }))
    
        const meshWainscotTrimModel_Temp = meshWainscotTrimModel.clone();
        meshWainscotTrimModel_Temp.rotation.y = Math.PI/-2
        meshWainscotTrimModel_Temp.position.set((params.p_d / 2 + 0.15),3, (params.p_w / 2));
        meshWainscotTrimModel_Temp.updateMatrixWorld();
    
        const meshWainscotDelModel_Temp = meshWainscotDelModel.clone();
        meshWainscotDelModel_Temp.rotateY(Math.PI)
        meshWainscotDelModel_Temp.position.set(params.endStoragePositionZ, 0, params.p_w / 2 + 0.5);
        meshWainscotDelModel_Temp.updateMatrixWorld();
    
        const meshWainscotTrimModel_CSG = CSG.fromMesh(meshWainscotTrimModel_Temp);
        const meshWainscotDelModel_CSG = CSG.fromMesh(meshWainscotDelModel_Temp);
    
        const wainscotTrimModel_CSG = meshWainscotTrimModel_CSG.subtract(meshWainscotDelModel_CSG);
        const CSGWainscotTrimModel = CSG.toMesh(
            wainscotTrimModel_CSG,
            new THREE.Matrix4()
        )

        return {
            wTrim: CSGWainscotTrimModel.geometry
        }
        
    }, [params.p_d, params.p_w, params.p_u_c, params.p_u_t, params.p_r_w, const_var.newDoorsArray, wallCloseState, params.endStoragePositionZ]);

    useMemo(() => {
        var wallCloseValue = -1;
        var tempCutState = -1;
        let leanHeightValue = -1;
        let finalHeight = (params.singleSlope && params.freeStandingSide === "right") ? params.p_h + ((params.p_r_p / 12) * params.p_w) : params.p_h

        if (params.p_r_w === 'Open') {
            wallCloseValue = -1;
        } else if (params.p_r_w === "One_Fourth_Close") {
            wallCloseValue = (finalHeight * 3) / 4;
        } else if (params.p_r_w === "Half_Close") {
            wallCloseValue = finalHeight / 2;
        } else if (params.p_r_w === "Three_Fourth_Close") {
            wallCloseValue = finalHeight / 4;
        } else if (params.p_r_w === "Close") {
            wallCloseValue = 0;
        } else {
            wallCloseValue = finalHeight - (3 * params.p_r_w) - 0.2;
        }

        if (params.p_c_p_r) {
            if (params.p_r_w === 'Open') {
                tempCutState = finalHeight - 1.5;
            } else {
                tempCutState = wallCloseValue - 1.5;
            }
        } else {
            tempCutState = wallCloseValue;
        }

        if (params.add_right_lean) {
            let leanFinalHeight = 0;
            if (params.leanStyle?.right === 'standard') leanFinalHeight = params.p_h - (params.leanR_p_h + (parseInt(params.b_l_t_r_pR)/12) * params.leanR_p_w);
            else leanFinalHeight = params.p_h - params.leanR_p_h;

            if (params.add_right_lean && leanFinalHeight > 0 &&  (Math.abs(params.p_r_w) * 3) -leanFinalHeight < 3)
            {    
                let wH = leanFinalHeight+0.2;
                tempCutState = params.p_h - wH + (params.p_r_s === 1 && const_var.roofRegularDst * 2);
            } else {
                if (!isNaN(params.p_r_w)) {
                    let wH = (3 * params.p_r_w) - 0.2;
                    tempCutState = finalHeight - wH + (params.p_r_s === 1 && const_var.roofRegularDst * 2);
                }   
            }
            if (tempCutState === 0 && params.p_r_w === 'Open') tempCutState = -1; 
        }
        if (params.p_c_p_r && params.add_right_lean) {
            setWallCloseState(tempCutState - 1.5);
            dispatch(setWallCloseStateWrap({'cbRightWallCloseState': tempCutState - 1.5}))
        } else {
            setWallCloseState(tempCutState);
            dispatch(setWallCloseStateWrap({'cbRightWallCloseState': tempCutState}))
        }
    }, [params.p_r_s, params.p_w, params.p_r_w, params.p_c_p_r, params.p_h, params.p_r_p, params.add_right_lean, params.leanR_p_h, params.leanR_p_w, params.b_l_t_r_pR, params.leanStyle?.right])

    return (
        <group name='c_b_l_s_w_trim-group' rotation={[0, Math.PI / 2, 0]}>
            {params.p_r_w !== 'Close' && 
                    <>
                        {params.endStoragePositionZ !== (params.p_d - parseInt(params.p_u_t)) && 
                            <>
                                <mesh name="back-storage-back-trim-one" position={[-0.22, 0, (params.p_w / 2 + 0.075)]}>
                                    <extrudeGeometry args={[backStorageTrimModelOne, extrudeSettings(-0.068)]} />
                                    <MaterialTrim visibleSection={"center"} />
                                </mesh>
                                <mesh name="back-storage-back-trim-two" position={[-0.27, 0, (params.p_w / 2 + 0.075)]}>
                                    <extrudeGeometry args={[backStorageTrimModelTwo, extrudeSettings(-0.23)]} />
                                    <MaterialTrim visibleSection={"center"} />
                                </mesh>  
                            </>
                        }
                        {params.endStoragePositionZ !== 0 && 
                            <>
                                <mesh name="back-storage-front-trim-one" position={[(parseInt(params.p_u_t) + 0.25) - 0.22, 0, (params.p_w / 2 + 0.075)]}>
                                    <extrudeGeometry args={[backStorageTrimModelOne, extrudeSettings(-0.068)]} />
                                    <MaterialTrim visibleSection={"center"} />
                                </mesh>
                                <mesh name="back-storage-front-trim-two" position={[(parseInt(params.p_u_t) + 0.4) - 0.17, 0, (params.p_w / 2 + 0.075)]}>
                                    <extrudeGeometry args={[backStorageTrimModelTwo, extrudeSettings(-0.23)]} />
                                    <MaterialTrim visibleSection={"center"} />
                                </mesh>
                            </>
                        }
                         
                    </> 
                }   

            {(params.p_w_c_n === true ) && mainTrimModel.wTrim && (
                <mesh name="wainscotRightTrim" geometry={mainTrimModel.wTrim}>
                    <MaterialWainScotTrimNew visibleSection={"center"}  />
                </mesh>
            )}
        </group>
    )
}

export default TrimModel